"use strict";

import $ from './node_modules/jquery/dist/jquery.min.js'

$(function() {
  const getIps = function() {
    $("#ipv4spinner").removeClass("d-none");
    $("#ipv4").addClass("d-none");
    $.ajax({
      type: "GET",
      url: "https://ipv4.cahier-snt.fr",
      dataType: "text",
      contentType: "text/plain",
      success: function(data, status) {
        console.log("IPv4", data, status);
        $("#ipv4spinner").addClass("d-none");
        $("#ipv4").html(data).removeClass("d-none");
      },
      error: function(data, status) {
        console.log("IPv4", data, status);
        $("#ipv4spinner").addClass("d-none");
        $("#ipv4").html("Pas d'IPv4").removeClass("d-none");
      },
    });
    $("#ipv6spinner").removeClass("d-none");
    $("#ipv6").addClass("d-none");
    $.ajax({
      type: "GET",
      url: "https://ipv6.cahier-snt.fr",
      dataType: "text",
      contentType: "text/plain",
      success: function(data, status) {
        console.log("IPv6", data, status);
        $("#ipv6spinner").addClass("d-none");
        $("#ipv6").html(data).removeClass("d-none");
      },
      error: function(data, status) {
        console.log("IPv6", data, status);
        $("#ipv6spinner").addClass("d-none");
        $("#ipv6").html("Pas d'IPv6").removeClass("d-none");
      },
    });
  }

  getIps();
});
